import React from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import BtnThemMoi from "./ThemMoi/BtnThemMoi";
import { ContentTable } from "./ContentTable";

export const TableDanhSach = ({ phanQuyen, listDanhSach, isLoading, dataSearch, setDataSearch, onSearch, onReload }) => {
    
    const handlePageChange = (pageNumber) => {
        setDataSearch(prev => ({ ...prev, iPageIndex: pageNumber }));
        onSearch({ ...dataSearch, iPageIndex: pageNumber });
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    const handlePageSizeChange = (pageSize) => {
        setDataSearch(prev => ({ ...prev, iPageSize: pageSize, iPageIndex: 1 }));
        onSearch({ ...dataSearch, iPageSize: pageSize, iPageIndex: 1 });
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    return (
        <>
            {isLoading ? (
                <div className="loading-page1">
                    <div className="loader loader-default is-active"></div>
                </div>
            ) : (
                <>
                    <div className="card border-light mb-2 card-v2">
                        <div className="card-body card-body-v2">
                            <div className="row col-sm-12 col-md-12 themoi-taisanthly mb-1">
                                <div className="col-sm-12 col-md-10">
                                    {phanQuyen.themmoi && <BtnThemMoi onReload={onReload} />}
                                </div>
                            </div>
                            <div className="Left808x200 Table-main-new css-table-ds">
                                <div className="table-mobile table-mobile-hover">
                                    <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                                        <div className="table-headers">
                                            <div className="custom-table-header flex-basis-5 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p className="color-do-bold">
                                                    STT
                                                    <br />[{listDanhSach.iTotal}]
                                                </p>
                                            </div>
                                            <div className="custom-table-header flex-basis-20 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p>Loại Kiểm Kê</p>
                                            </div>
                                            <div className="custom-table-header flex-basis-30 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p>Ngày tạo</p>
                                            </div>
                                            <div className="custom-table-header flex-basis-30 text-left" style={{ justifyContent: 'flex-start' }}>
                                                <p>Người tạo</p>
                                            </div>
                                            <div className="custom-table-header flex-basis-15 text-center" style={{ justifyContent: 'center' }}>
                                                <p>Chức năng</p>
                                            </div>
                                        </div>
                                        
                                        <div className="custom-table-body">
                                            <ContentTable 
                                                listDanhSach={listDanhSach.List} 
                                                phanQuyen={phanQuyen} 
                                                onReload={onReload}
                                                dataSearch={dataSearch}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card border-light mb-2 card-v2" >
                        <div className="card-body card-body-v2">
                            <PhanTrang
                                pageIndex={dataSearch.iPageIndex}
                                pageSize={dataSearch.iPageSize}
                                totalCount={listDanhSach.iTotal}
                                onPageChange={handlePageChange}
                                onPageSizeChange={handlePageSizeChange}
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};